export class Taxo {
    public bandingCodes: string;
    public category: string;
    public comName: string;
    public comNameCodes: string;
    public ebirdSpeciesGroup: string;
    public family: string;
    public id: number;
    public idIdioma: string;
    public pic: string;
    public range: string;
    public sciName: string;
    public sciNameCodes: string;
    public speciesCode: string;
    public taxonId: string;
    public taxonOrder: number;
}
